export class UpadteDataModel {
    "patientId": String;
    "sectionId": Number;
    "userId": Number
    "fromDate": any;
    "toDate": any;
}